import * as actions from 'actions/currentOrganization';
import { REMOVE_COMPANY_LOGO_SUCCESS } from 'actions/settings';

const {
  GET_INFO_SUCCESS,
  GET_INFO_START,
  GET_DISCLAIMER_SUCCESS,
  GET_LOGO_URL_SUCCESS,
} = actions;

const defaultState = {
  userQuota: -1,
  numUsers: 0,
  hostedRegion: 'north_america',
};

export default function currentOrganization(state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
    // dispatched from GWT
    case 'COMPANY_LOGO_URL':
      return {
        ...state,
        companyLogoUrl: payload,
      };
    case REMOVE_COMPANY_LOGO_SUCCESS:
      return {
        ...state,
        companyLogoUrl: null,
      };
    case GET_INFO_START:
      return {
        ...state,
        currentOrganizationRequestStatus: 'LOADING',
      };
    case GET_INFO_SUCCESS:
      return {
        ...state,
        info: payload || state.info,
        currentOrganizationRequestStatus: 'LOADED',
      };
    case GET_DISCLAIMER_SUCCESS:
      return {
        ...state,
        disclaimer: payload.value || state.disclaimer,
      };
    case GET_LOGO_URL_SUCCESS:
      return {
        ...state,
        logoUrl: payload.value || state.logoUrl,
      };
    default:
      return state;
  }
}
